﻿import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import Select from "react-select";

import { Row, Col, Form, Modal, Button } from "react-bootstrap";

import classes from "../../maintainers.module.scss";

import { hasPermission, toast } from "@/services/Utils";
import api from "@/services/api.service";
import Fetching from "@/components/Fetching/Fetching";

import { customStyles } from "../varieties.constants";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const VarietiesForm = ({ species, categories, confirmSave, permissions }) => {
	const { addToast } = useToasts();
	const location = useLocation();
	const { option, slug } = useParams();
	const navigate = useNavigate();

	const [isFetching, setIsFetching] = useState(true);
	const [name, setName] = useState("");
	const [description, setDescription] = useState("");
	const [customer, setCustomer] = useState("");
	const [specie, setSpecie] = useState("");
	const [category, setCategory] = useState("");

	const handleClose = () => {
		emptyFields();
		if (location.state) {
			navigate(location.state);
			return;
		}

		if (location.pathname.includes("configuracion")) {
			navigate("/configuracion/paso-2");
			return;
		}

		if (location.pathname.includes("mantenedores")) {
			navigate("/mantenedores/paso-2");
			return;
		}
	};

	const validSave = () => {
		let search_specie = species.filter((s) => Number(s.value) === Number(specie));

		if (!specie || search_specie.length === 0) {
			toast(addToast, "Debe seleccionar una elemento del paso 1 para guardar.", "error");
			return false;
		}

		if (!name) {
			toast(addToast, "Debe ingresar un nombre para guardar.", "error");
			return false;
		}

		if (!customer && location.pathname.includes("mantenedores")) {
			addToast("Debe seleccionar un cliente para guardar.", {
				appearance: "error",
			});

			return false;
		}

		return true;
	};

	const handleSave = () => {
		const form = {
			slug,
			name,
			description,
			specie,
			customer,
		};

		if (validSave()) {
			confirmSave(form, setIsFetching, afterSave);
		}
	};

	const emptyFields = () => {
		setName("");
		setDescription("");
		setCategory("");
		setSpecie("");
		setCustomer("");
	};

	const afterSave = () => {
		handleClose();
		addToast("Variedad guardada correctamente.", {
			appearance: "success",
		});
	};

	useEffect(() => {
		setIsFetching(true);
		if (option && slug) {
			api.get("/admin/varieties/detail", { slug }).then((response) => {
				const { detail } = response;
				if (detail) {
					setName(detail.name ? detail.name : "");
					setDescription(detail.description ? detail.description : "");
					setCustomer(detail.customer_id ? detail.customer_id : "");
					setSpecie(detail.specie ? detail.specie : "");
					setCategory(detail.category_id ? detail.category_id : "");
				} else {
					addToast("Ocurrió un problema al cargar el registro seleccionado.", {
						appearance: "error",
					});
					handleClose();
				}
				setIsFetching(false);
			});
		} else {
			setIsFetching(false);
		}
		// eslint-disable-next-line
	}, [slug, option]);

	return (
		<Modal show={option ? true : false} onHide={handleClose} backdrop="static" keyboard={false} className={classes.main_form}>
			<Modal.Header closeButton>
				<h4 className={classes.modal_title}>Paso 2</h4>
			</Modal.Header>

			<Modal.Body>
				{isFetching ? (
					<Fetching topMargin={"1em"} />
				) : (
					<Row className={classes.row_form}>
						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Nombre</Form.Label>

								<Form.Control value={name} onChange={(e) => setName(e.currentTarget.value)} type="text" />
							</Form.Group>
						</Col>

						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Categoría</Form.Label>

								<Select
									styles={customStyles}
									options={categories ? categories : []}
									value={categories && categories.filter((b) => Number(b.value) === Number(category))}
									components={{
										NoOptionsMessage,
									}}
									onChange={(value) => setCategory(value.value)}
									placeholder={"Seleccione..."}
								/>
							</Form.Group>
						</Col>

						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Paso 1</Form.Label>

								<Select
									styles={customStyles}
									options={species ? species.filter((s) => Number(s.category_id) === Number(category)) : []}
									value={species && species.filter((b) => Number(b.value) === Number(specie))}
									components={{
										NoOptionsMessage,
									}}
									onChange={(value) => setSpecie(value.value)}
									placeholder={"Seleccione..."}
								/>
							</Form.Group>
						</Col>
					</Row>
				)}
			</Modal.Body>
			<Modal.Footer>
				{(slug ? hasPermission("edit", permissions) : hasPermission("create", permissions)) && !isFetching && (
					<Button variant="success" onClick={handleSave}>
						GUARDAR
					</Button>
				)}
			</Modal.Footer>
		</Modal>
	);
};

export default VarietiesForm;
